export const environment = {
  production: true,
  isMockEnabled: true, // You have to switch this, when your real back-end is done
  codigoSistema: '0001',
  timeToRefreshToken: 600000,//10 min

  jwt: {
    audience: 'DefaultAudience',
    issuer: 'DefaultIssuer'
  },

  /*WEB SERVICES*/
  api: {
    WS_IT: {
      url: 'https://webmissionproduce.com:4430/api/WS_IT',
      basicAuthorization: {
        username: 'ProdITApp',
        password: '975318642'
      }
    },
    WS_IND: {
      url: 'https://webmissionproduce.com:4430/api/WS_IND',
      basicAuthorization: {
        username: '',
        password: ''
      }
    },
    WS_HCM: {
      url: 'https://webmissionproduce.com:4430/api/WS_HCM',
      basicAuthorization: {
        username: '',
        password: ''
      }
    },
    WS_AGR: {
      url: 'https://webmissionproduce.com:4430/api/WS_AGR',
      basicAuthorization: {
        username: '',
        password: ''
      }
    },
    WS_QM: {
      url: 'https://webmissionproduce.com:4430/api/WS_QM',
      basicAuthorization: {
        username: '',
        password: ''
      }
    },
    WS_INS: {
      url: 'https://webmissionproduce.com:4430/api/WS_INS',
      basicAuthorization: {
        username: '',
        password: ''
      }
    },
    WS_TRAZ: {
      url: 'https://webmissionproduce.com:4430/api/WS_TRAZ',
      basicAuthorization: {
        username: '',
        password: ''
      }
    },
    WS_TAG: {
      url: 'https://webmissionproduce.com:4430/api/WS_TAG',
      basicAuthorization: {
        username: '',
        password: ''
      }
    }
  },

  firebaseTiendas: {
    apiKey: "AIzaSyAZYWOpJXwAdoke_3zeeAvcFQh1qgDcVdI",
    authDomain: "ventasinternas.firebaseapp.com",
    databaseURL: "https://ventasinternas.firebaseio.com",
    projectId: "ventasinternas",
    storageBucket: "ventasinternas.appspot.com",
    messagingSenderId: "685579128412",
    appId: "1:685579128412:web:f9cd13b7148b94ac3aa099",
    measurementId: "G-P8XEX4S8S3"
  }
};

